import Carousel from './Carousel'
export default Carousel
